



































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat } from "@/utils/index";
import { Options } from "@/request/automaticOutgoingCallRecord";

@Component({
  name: "automaticOutgoingCall",
})
export default class automaticOutgoingCall extends Vue {
  @Provide() private searchForm: any = {
    accountId: null,// 用户账号
    orderId: null,// 用户账号
    calledMobile: null,//被叫手机号
    showMobile: null,//外显手机号
    supplier: null, //外呼渠道
    pickDate: null, // 呼叫创建时间
    outbondDate: null, // 真实外呼创建时间
  };
  @Provide() private labelPosition: string = "right";
  @Provide() private pickerOptions: any = {
    onPick: (opt: any) => { },
    start: "00:00",
    step: "00:10",
    end: "23: 50",
  };
  @Provide() private outboundTimeOptions: any = {
    onPick: (opt: any) => { },
    start: "00:00",
    step: "00:10",
    end: "23: 50",
  };
  @Provide() private resultData: any = []; //table列表
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private isSearchFormActionDone: boolean = false; //loading
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数 目前分页是自己处理的
  @Provide() private pagnition: any = pagnition;
  @Provide() private outboundOptions: any = [];
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");
    this.getSupplierOptions();
  }
  // 获取外呼渠道下拉内容
  private getSupplierOptions() {
    // 外呼渠道 Nxtele，Infinity，Sti
    this.outboundOptions = [
      { value: 1, name: "Nxtele", in: 'Chan-2' },
      { value: 2, name: "Infinity", in: 'Chan-3' },
      { value: 3, name: "Sti", in: 'Sti' },
    ];
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getExtenList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getExtenList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getExtenList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getExtenList();
  }
  // lee 搜索操作的判断
  private testSearchForm(): boolean {
    if (this.searchForm.pickDate && this.searchForm.pickDate.length > 0) {
      return true;
    } else {
      this.$message.error("Please choose the Creation time");
      return false;
    }
  }
  //  lee 搜索操作
  private searchFormAction() {
    if (this.testSearchForm()) {
      this.pagerCount = 0;
      this.pageIndex = 1;
      this.isSearchFormActionDone = true;
      this.getExtenList();
    }
  }
  // 搜索框信息
  private searchAction(): any {
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      },
      orderId: this.searchForm.orderId, //订单号
      accountId: this.searchForm.accountId, //用户账号
      calledMobile: this.searchForm.calledMobile,
      showMobile: this.searchForm.showMobile,
      supplier: this.searchForm.supplier
    };
    if (this.searchForm.pickDate && this.searchForm.pickDate.length > 0) {
      _arg.createCallTimeRange = timeFormat(this.searchForm.pickDate[0].getTime()) +
        " - " +
        timeFormat(this.searchForm.pickDate[1].getTime())
    }
    if (this.searchForm.outbondDate && this.searchForm.outbondDate.length > 0) {
      _arg.trueCallTimeRange = timeFormat(this.searchForm.outbondDate[0].getTime()) +
        " - " +
        timeFormat(this.searchForm.outbondDate[1].getTime())
    }
    return _arg;
  }
  //   获取列表
  private async getExtenList() {
    let _arg: any = this.searchAction();
    const { getDialListReq, getDialListRequest }: any = await import(
      "@/request/automaticOutgoingCallRecord"
    );
    let res = await getDialListRequest.handleHttp(
      getDialListReq(_arg),
      this
    );
    this.isSearchFormActionDone = res ? res.loading : false;
    if (res) {
      let _result =
        typeof res.respdataList == "object"
          ? res.respdataList
          : JSON.parse(res.respdataList);
      if (_result) {
        this.resultData = _result.map((item: any) => {
          item.callcreatetime = timeFormat(Number(item.callcreatetime));
          item.callstarttime = timeFormat(Number(item.callstarttime));
          item.callendtime = timeFormat(Number(item.callendtime));
          return item;
        });
      }
      if (res.pageout || res.total) {
        this.pagerCount = res.total ? res.total : res.pageout.total;
      }
    }
  }
}
